import { render } from "./ThreeGameList.vue?vue&type=template&id=60d6ea2e&scoped=true"
import script from "./ThreeGameList.vue?vue&type=script&lang=js"
export * from "./ThreeGameList.vue?vue&type=script&lang=js"

import "./ThreeGameList.vue?vue&type=style&index=0&id=60d6ea2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d6ea2e"]])

export default __exports__